// Configuración de marca - Cambiar aquí para rebrandear toda la aplicación
const BRAND_CONFIG = {
  // Opciones: 'BLUECMR' | 'DOCUPORTE' | 'MIS_DOCUMENTOS' | 'CUSTOM'
  ACTIVE_BRAND: 'BLUECMR'
};
 
// Definiciones de marcas
const BRANDS = {
  BLUECMR: {
    name: 'BlueCMR',
    shortName: 'BlueCMR',
    legalName: 'BLUECMR, S.L.U.',
    tagline: 'Documentos de Transporte Digitales',
    domain: 'bluecmr.com',
    url: 'https://www.bluecmr.com',
    theme: 'blue'
  },
  DOCUPORTE: {
    name: 'DOCUPORTE',
    shortName: 'DOCUPORTE',
    tagline: 'Documentos de transporte digitales y elegantes',
    domain: 'docuporte.com',
    url: 'https://docuporte.com',
    theme: 'green'
  },
  CADENIA_DOCS: {
    name: 'Cadenia Docs',
    shortName: 'Cadenia Docs',
    tagline: 'Documentos de transporte digitales',
    domain: 'cadeniadocs.com',
    url: 'https://cadeniadocs.com',
    theme: 'blue'
  },
  MIS_DOCUMENTOS: {
    name: 'Mis Documentos De Transporte',
    shortName: 'Mis Documentos',
    tagline: 'La solución definitiva para cumplir la normativa española de transporte',
    domain: 'midocumentodecontrol.com',
    url: 'https://midocumentodecontrol.com',
    theme: 'blue'
  },
  CUSTOM: {
    name: 'Tu Marca Aquí',
    shortName: 'Tu Marca',
    tagline: 'Tu tagline personalizado',
    domain: 'tumarca.com',
    url: 'https://tumarca.com',
    theme: 'green'
  }
};

// Marca activa
const activeBrand = BRANDS[BRAND_CONFIG.ACTIVE_BRAND] || BRANDS.DOCUPORTE;

export const BRAND = {
  ...activeBrand,
  
  // SEO - Dinámico basado en la marca activa
  description: `${activeBrand.name} - Plataforma SaaS para crear, firmar y gestionar documentos de transporte con validez legal. Incluye firma electrónica avanzada, plantillas personalizables y enlaces públicos seguros.`,
  keywords: `${activeBrand.name.toLowerCase()}, documentos transporte, firma electronica, ecmr, carta porte, documento control, efti, eidas, pwa movil`,
  
  // Social
  social: {
    title: `${activeBrand.name} - Documentos de transporte profesionales`,
    description: `La plataforma más profesional para generar documentos de control digital. Diseño profesional y cumplimiento normativo garantizado.`
  },
  
  // Contact
  contact: {
    email: `soporte@${activeBrand.domain}`,
    phone: '+34 900 123 456'
  },
  
  // Colors (Tailwind classes)
  colors: {
    primary: 'primary-600',
    primaryHover: 'primary-700',
    secondary: 'gray-600',
    accent: 'accent-600'
  },
  
  // Configuración interna
  config: BRAND_CONFIG
};

// Utilidad para cambiar marca
export const setBrand = (brandKey) => {
  if (BRANDS[brandKey]) {
    BRAND_CONFIG.ACTIVE_BRAND = brandKey;
    return true;
  }
  return false;
};

// Obtener todas las marcas disponibles
export const getAvailableBrands = () => Object.keys(BRANDS);

export default BRAND;
